import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { FilterRule } from 'src/app/modules/shared/models/section-config.model';
import { SectionConfigModel } from '../../../models/section-configuration.model';

@Component({
    selector: 'rules-data-filter',
    templateUrl: 'rules-data-filter.component.html',
    styleUrls: ['rules-data-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RulesDataFilterComponent implements OnInit {
  @Input() sectionConfig: SectionConfigModel;
  @Input() parentFormGroup: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.addControls();
  }

  addNewRule(): void {
    const emptyRule = {
      includeCategories: [],
      excludeCategories: [],
      services: []
    };

    this.getFormArrayElements().insert(0, this.mapRuleToFormGroup(emptyRule));

    if (!this.sectionConfig.filter.rules) {
      this.sectionConfig.filter.rules = [];
    }

    this.sectionConfig.filter.rules.unshift(emptyRule);
  }

  getRulesFormGroup(i: number): FormGroup {
    return this.getFormArrayElements().controls[i] as FormGroup;
  }

  deleteRule(index): void {
    const formArray = this.getFormArrayElements();

    this.sectionConfig.filter.rules.splice(index, 1);
    formArray.removeAt(index);
  }

  private getFormArrayElements(): FormArray {
    return <FormArray>this.parentFormGroup.controls['rules'];
  }

  private addControls(): void {
    this.parentFormGroup.addControl('rules', this.fb.array(this.sectionConfig.filter.rules?.map(rule => this.mapRuleToFormGroup(rule)) ?? []));
  }

  private mapRuleToFormGroup(rule: FilterRule): FormGroup {
    return this.fb.group({
      includeCategories: this.fb.control(rule.includeCategories ?? []),
      excludeCategories: this.fb.control(rule.excludeCategories ?? []),
      services: this.fb.control(rule.services ?? [])
    });
  }
}
